import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { FAQSection } from '../components/FAQSection';
import { PricingBlock } from '../components/PricingBlock';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-[#FDF8F3] text-[#3D2B1F] font-sans selection:bg-[#C4704B] selection:text-white overflow-x-hidden" data-id="element-106">
      <style data-id="element-107">{`
        @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,400&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap');
        
        :root {
          --font-heading: 'Playfair Display', serif;
          --font-body: 'Lato', sans-serif;
        }
        
        h1, h2, h3, h4, h5, h6 {
          font-family: var(--font-heading);
        }
        
        body {
          font-family: var(--font-body);
        }
      `}</style>

      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20 space-y-24 md:space-y-32" data-id="element-108">
        <HeroSection data-id="element-109" />
        <div className="w-full h-px bg-[#C4704B]/20 mx-auto max-w-xs" data-id="element-110" />
        <ProblemSection data-id="element-111" />
        <div className="w-full h-px bg-[#C4704B]/20 mx-auto max-w-xs" data-id="element-112" />
        <SolutionSection data-id="element-113" />
        <div className="w-full h-px bg-[#C4704B]/20 mx-auto max-w-xs" data-id="element-114" />
        <AudienceSection data-id="element-115" />
        <div className="w-full h-px bg-[#C4704B]/20 mx-auto max-w-xs" data-id="element-116" />
        <FAQSection data-id="element-117" />
        <div className="w-full h-px bg-[#C4704B]/20 mx-auto max-w-xs" data-id="element-118" />
        <PricingBlock data-id="element-119" />
      </main>

      <footer className="text-center py-12 text-[#3D2B1F]/60 text-sm font-body" data-id="element-120">
        <p data-id="element-121">© 2024 El Fin de la Supermujer. Todos los derechos reservados.</p>
      </footer>
    </div>;
}